"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.SpectrumLogQueue = void 0;
var events_1 = require("@snapchat/ts-protos/spectrum/streaming/schema/autogenerated/typescript/events");
var frame_1 = require("@snapchat/ts-protos/spectrum/streaming/schema/frame");
var logger_1 = require("../../logger");
var common_client_header_1 = require("@snapchat/ts-protos/spectrum/streaming/schema/client/common_client_header");
var grapheneMetrics_1 = require("../../grapheneMetrics");
var transmit_1 = require("../../network/transmit");
var environment_1 = require("../../environment");
var spectrumUtils_1 = require("../../util/spectrumUtils");
var spectrumBatchingSize = 1;
var spectrumBatchingTimeout = 1000;
var SpectrumLogQueue = (function () {
    function SpectrumLogQueue(logQueueName, region) {
        this.region = common_client_header_1.Region.REGION_US_CENTRAL_1;
        this.sequenceId = 1;
        this.timeoutId = undefined;
        this.eventBuffer = [];
        this.eventBufferNameList = [];
        this.clientReferenceTs = -1;
        this.logQueueName = logQueueName;
        this.region = region;
        this.log = (0, logger_1.getLogger)("spectrumLogQueue.".concat(logQueueName, "-").concat(region));
    }
    SpectrumLogQueue.prototype.append = function (item) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var event_1;
            return __generator(this, function (_c) {
                try {
                    if ((0, spectrumUtils_1.isSpectrumHeader)(item)) {
                        this.log.debug("Saw new SpectrumHeader, converting/copying for this queue");
                        if (this.lastSpectrumHeader) {
                            this.flush("header_changed");
                        }
                        this.lastSpectrumHeader = convertSpectrumHeader(this.logQueueName, this.region, item);
                    }
                    else if ((0, spectrumUtils_1.isSpectrumEvent)(item)) {
                        if (!this.lastSpectrumHeader) {
                            grapheneMetrics_1.blizzardGraphene.increment({
                                metricsName: grapheneMetrics_1.STREAM_EVENT_BEFORE_HEADER
                            });
                            throw new Error("Event before SpectrumHeader");
                        }
                        if (this.eventBuffer.length === 0) {
                            this.clientReferenceTs = performance.now();
                        }
                        event_1 = convertEvent(item, this.sequenceId++);
                        this.eventBuffer.push(event_1);
                        this.eventBufferNameList.push(((_a = item.event) === null || _a === void 0 ? void 0 : _a.$case) ? (_b = item.event) === null || _b === void 0 ? void 0 : _b.$case : "undefined");
                        this.maybeFlushAfterAppend();
                    }
                    else {
                        grapheneMetrics_1.blizzardGraphene.increment({
                            metricsName: grapheneMetrics_1.STREAM_EVENT_ILLEGAL_ITEMS
                        });
                        throw new Error("Illegal item: " + item);
                    }
                }
                catch (e) {
                    grapheneMetrics_1.blizzardGraphene.increment({
                        metricsName: grapheneMetrics_1.STREAM_EVENT_APPEND_ERROR
                    });
                    this.log.error(e);
                }
                return [2];
            });
        });
    };
    SpectrumLogQueue.prototype.flush = function (reason) {
        try {
            grapheneMetrics_1.blizzardGraphene.increment({
                metricsName: grapheneMetrics_1.STREAM_EVENT_FLUSH,
                dimensions: {
                    reason: reason,
                    status: "attempt"
                }
            });
            this.log.debug("Flush starts. Reason: ", reason);
            if (!this.shouldFlush()) {
                return;
            }
            var header = this.lastSpectrumHeader;
            var eventsToTransmit = __spreadArray([], __read(this.eventBuffer), false);
            this.eventBuffer = [];
            (0, transmit_1.transmitSpectrumEvents)(header, eventsToTransmit, this.region);
            this.logMetricsAfterFlush(eventsToTransmit.length, Math.round(performance.now() - this.clientReferenceTs));
            this.clearFlushTimer();
            grapheneMetrics_1.blizzardGraphene.increment({
                metricsName: grapheneMetrics_1.STREAM_EVENT_FLUSH,
                dimensions: {
                    reason: reason,
                    status: "success"
                }
            });
        }
        catch (e) {
            grapheneMetrics_1.blizzardGraphene.increment({
                metricsName: grapheneMetrics_1.STREAM_EVENT_FLUSH_ERROR
            });
            this.log.error(e);
        }
    };
    SpectrumLogQueue.prototype.maybeFlushAfterAppend = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.eventBuffer.length >= spectrumBatchingSize) {
                    this.flush("batch_size_limit_reached");
                }
                else {
                    this.startFlushTimer();
                }
                return [2];
            });
        });
    };
    SpectrumLogQueue.prototype.startFlushTimer = function () {
        return __awaiter(this, void 0, void 0, function () {
            var timeoutToFlushMillsecs;
            var _this = this;
            return __generator(this, function (_a) {
                timeoutToFlushMillsecs = spectrumBatchingTimeout;
                if (this.timeoutId === undefined) {
                    this.timeoutId = setTimeout(function () {
                        _this.flush("timeout");
                    }, timeoutToFlushMillsecs);
                }
                return [2];
            });
        });
    };
    SpectrumLogQueue.prototype.clearFlushTimer = function () {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = undefined;
        }
    };
    SpectrumLogQueue.prototype.shouldFlush = function () {
        if (this.eventBuffer.length === 0) {
            grapheneMetrics_1.blizzardGraphene.increment({
                metricsName: grapheneMetrics_1.STREAM_EVENT_EMPTY_BATCH_AT_FLUSH
            });
            this.log.debug("Flush receives empty eventBuffer. Do nothing and return.");
            return false;
        }
        if (!this.lastSpectrumHeader) {
            grapheneMetrics_1.blizzardGraphene.increment({
                metricsName: grapheneMetrics_1.STREAM_EVENT_NO_FRAME_START_AT_FLUSH
            });
            throw new Error("No frameStart when flushing");
        }
        return true;
    };
    SpectrumLogQueue.prototype.logMetricsAfterFlush = function (bufferSize, flushTimeMilliSec) {
        var _a;
        grapheneMetrics_1.blizzardGraphene.addHistogram({
            metricsName: grapheneMetrics_1.STREAM_EVENT_BATCHING_BUFFER_SIZE,
            value: bufferSize
        });
        for (var i = 0; i < this.eventBufferNameList.length; i++) {
            this.log.debug(this.eventBufferNameList[i], " is uploaded.");
            grapheneMetrics_1.blizzardGraphene.increment({
                metricsName: grapheneMetrics_1.STREAM_EVENTS_FLUSHED,
                dimensions: {
                    name: this.eventBufferNameList[i],
                    app: (_a = (0, environment_1.getAppEnvironment)().application) !== null && _a !== void 0 ? _a : ""
                }
            });
        }
        this.eventBufferNameList = [];
        grapheneMetrics_1.blizzardGraphene.addTimer({
            metricsName: grapheneMetrics_1.STREAM_EVENT_BATCH_LIFETIME_TILL_FLUSH_MS,
            milliSec: Math.round(flushTimeMilliSec)
        });
    };
    return SpectrumLogQueue;
}());
exports.SpectrumLogQueue = SpectrumLogQueue;
function convertSpectrumHeader(logQueueName, region, header) {
    return common_client_header_1.DefaultClientHeader.fromPartial({
        sessionId: header.sessionId,
        userGuid: header.userGuid,
        appBuild: header.appBuild,
        appVersion: header.appVersion,
        osVersion: header.osVersion,
        osType: header.osType,
        clientId: header.clientId,
        locale: header.locale,
        deviceModel: header.deviceModel,
        appStartupType: header.appStartupType,
        queueName: logQueueName,
        region: region
    });
}
function convertEvent(event, sequenceId) {
    var currentTimeMillisString = new Date().getTime().toString();
    return frame_1.EventEnvelope.fromPartial({
        sequenceNumber: sequenceId.toString(),
        eventBytes: events_1.Event.encode(event).finish(),
        clientEpochMs: currentTimeMillisString,
        clientNodepEpochMs: currentTimeMillisString
    });
}
//# sourceMappingURL=spectrumLogQueue.js.map